import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, FormLayout, TextField, Checkbox, Button, AppProvider, Heading, Page } from '@shopify/polaris';
import translations from '@shopify/polaris/locales/es.json';
import { Formik } from 'formik';

const propTypes = {
  
};

const defaultValues = {
  mercy: false,
  email: ""
}

class WarrantyFormWrapper extends Component {
  constructor(props) {
    super(props);
    this.state= {
      ...defaultValues // When using polaris instead of formik
    }
  }
  

  submit = (values, formikProps) => {
    console.log("SUBMIT!", values)
  }


  polarisSubmit = () => {
    console.log("Polaris Submit", this.state);
  }

  handlePolarisChange = (field) => {
    return (value) => this.setState({ [field]: value });
  }

  render() {
    return (
      <AppProvider i18n={translations}>
        <Page>
          {/* FORMIK */}
          <Heading>
            WITH FORMIK
          </Heading>
          <Formik
            initialValues={defaultValues}
            onSubmit={ this.submit }
          >
            { ({ handleChange, handleSubmit, values, setFieldValue }) =>
              <Form onSubmit={handleSubmit}>
                <FormLayout>
                  <Checkbox
                    label="have mercy with me!"
                    checked={ values.mercy }
                    name="mercy"
                    onChange={(value) => setFieldValue("mercy", value)}
                  />
      
                  <TextField
                    value={ values.email }
                    name="email"
                    onChange={(value) => setFieldValue("email", value)}
                    label="Email"
                    type="email"
                    helpText={
                      <span>
                        Some email input
                      </span>
                    }
                  />
      
                  <Button submit>Submit</Button>
                </FormLayout>
              </Form>
            }
          </Formik>

          {/* No FORMIK */}
          <Heading>
            Without Formik.
          </Heading>
          <Form onSubmit={this.polarisSubmit}>
            <FormLayout>
              <Checkbox
                label="have mercy with me!"
                checked={ this.state.mercy}
                name="mercy"
                onChange={ this.handlePolarisChange("mercy") }
              />

              <TextField
                value={ this.state.email}
                name="email"
                onChange={ this.handlePolarisChange("email") }
                label="Email"
                type="email"
                helpText={
                  <span>
                    Some email input
                  </span>
                }
              />
              <Button submit>Submit</Button>
            </FormLayout>
          </Form>
        </Page>
      </AppProvider>
    );
  }
}


WarrantyFormWrapper.propTypes = propTypes;


export default WarrantyFormWrapper;
